/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UserShortCard_user = {
    readonly slugId: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly backgroundPhoto: {
        readonly id: string;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"UserPrimaryPhoto_user" | "UserBackgroundPhoto_user">;
    readonly " $refType": "UserShortCard_user";
};
export type UserShortCard_user$data = UserShortCard_user;
export type UserShortCard_user$key = {
    readonly " $data"?: UserShortCard_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"UserShortCard_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserShortCard_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhoto_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserBackgroundPhoto_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'babed60ad289c984547126751ec66d14';
export default node;
